module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card__spec",
    class: _vm.specId
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.specId === 'horseUser'),
      expression: "specId === 'horseUser'"
    }],
    staticClass: "spec__title",
    class: _vm.selectedSpecialCard ? 'spec__title__crispr' : ''
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_spec_title.png"),
      "alt": "あなたのユニコーン"
    }
  }), _vm._v(" "), (_vm.selectedSpecialCard) ? _c('span', {
    staticClass: "spec__crispr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_crispr_cas.png"),
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "spec__detail"
  }, [_c('p', {
    staticClass: "spec__detail--title"
  }, [_vm._v("スピード")]), _vm._v(" "), _c('p', {
    staticClass: "spec__detail--value"
  }, [_vm._v(_vm._s(_vm.specCard.speed))])]), _vm._v(" "), _c('div', {
    staticClass: "spec__detail"
  }, [_c('p', {
    staticClass: "spec__detail--title"
  }, [_vm._v("スタミナ")]), _vm._v(" "), _c('p', {
    staticClass: "spec__detail--value"
  }, [_vm._v(_vm._s(_vm.specCard.stamina))])]), _vm._v(" "), _c('div', {
    staticClass: "spec__detail"
  }, [_c('p', {
    staticClass: "spec__detail--title"
  }, [_vm._v("コンジョウ")]), _vm._v(" "), _c('p', {
    staticClass: "spec__detail--value"
  }, [_vm._v(_vm._s(_vm.specCard.brave))])]), _vm._v(" "), _c('div', {
    staticClass: "spec__detail"
  }, [_c('p', {
    staticClass: "spec__detail--title"
  }, [_vm._v("オチツキ")]), _vm._v(" "), _c('p', {
    staticClass: "spec__detail--value"
  }, [_vm._v(_vm._s(_vm.specCard.calm))])]), _vm._v(" "), _c('div', {
    staticClass: "spec__detail"
  }, [_c('p', {
    staticClass: "spec__detail--title"
  }, [_vm._v("ケンコウ")]), _vm._v(" "), _c('p', {
    staticClass: "spec__detail--value"
  }, [_vm._v(_vm._s(_vm.specCard.health))])]), _vm._v(" "), _c('div', {
    staticClass: "spec__detail"
  }, [_c('p', {
    staticClass: "spec__detail--title"
  }, [_vm._v("セイベツ")]), _vm._v(" "), _c('p', {
    staticClass: "spec__detail--value sex"
  }, [_vm._v(_vm._s(_vm.specCard.sex))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentScreen === 'decisionCard' && _vm.specId === 'horsePc'),
      expression: "currentScreen === 'decisionCard' && specId === 'horsePc'"
    }],
    staticClass: "spec__title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_spec_title2.png"),
      "alt": "競争相手のユニコーン"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e8a9ee3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardSpec.vue
// module id = 73
// module chunks = 0